export default {
  install: (Vue, options) => {
    Vue.prototype.$helpers = {
      info(url) {
        if (options.$wind == null) {
          options.$wind = [];
        }
        var wind = window.open(url, "info", "toolbar=yes,scrollbars=yes,resizable=yes,top=0,left=0,width=1000,height=970");
        options.$wind.push(wind);
      },
      open(url, name) {
        if (options.$wind == null) {
          options.$wind = [];
        }
        var wind = window.open(url, name, "toolbar=no,scrollbars=yes,resizable=yes,width=1280,height=720");
        // options.$wind.push(wind);
      },
      logout() {
        // if (options.$info) {
        //   options.$info.close();
        // }
        for (var n in options.$wind) {
          options.$wind[n].close();
        }

        if (options.$store.getters.isLoggedIn) {
          options.$store.dispatch("user/doLogout").then(
            res => {
              if (options.$router) {
                try {
                  options.$router.push("/");
                } catch (err) {
                  console.log(err);
                }
              }
            },
            err => {
              console.log("logout", err);
            }
          );
        }
      },
      handleFeedback(e, force) {
        var result = false;
        var isLoggedIn = true;

        if (options.$store) {
          isLoggedIn = options.$store.getters.isLoggedIn;
        }
        if (e != null && e.includes(" ")) {
          // this.logout();
          options.$swal("Error", e, "error");
          return result;
        }
        switch (e) {
          case "account_inactive":
          case "login_id_not_exists":
          case "session_not_exists":
          case "session_expired":
          case "invalidSession":
          case "permission_denied":
          case "accountIdRequired":
          case "BLOCK":
          case "CLOSE":
            if (isLoggedIn) {
              // options.$snotify.warning(options.$i18n.t("error." + e));
              options.$swal("Warning", options.$i18n.t("error." + e), "warning").then(result => {});
            } else {
              options.$swal("Error", options.$i18n.t("error." + e), "error").then((result) => {});
            }
            this.logout();
            break;
          case "requestLimit":
          case "requestProcessing":
          case "requestPending":
          case "requestTimeout":
          case undefined:
          case null:
          case "loginLimit":
          case "timeoutError":
          case "systemError":
          case "insufficient_balance":
            if (force === true) {
              options.$swal("Error", options.$i18n.t("error." + e), "error").then((result) => {});
            }
            result = true;
            break;
          case "requestFailed":
              options.$store.dispatch("layout/setNetwork", "failed");
              console.warn(e);
              if (force === true) {
                options.$swal("Warning", options.$i18n.t("error." + e), "warning").then(result => {});
              }
              result = true;
              break;
          case "incompletedRequest":
          case "unableToGetBalanceAtTheMoment":
          case "duplicate_debit_record":
          case "test":
            options.$swal("Warning", options.$i18n.t("error." + e), "warning").then(result => {});
            result = true;
            break;
          case "liveCasinoDisabled":
          case "lotteryDisabled":
          case "MiniGameDisabled":
            break;
          default:
            options.$swal("Error", options.$i18n.t("error." + e), "error").then(result => {});
            break;
        }
        return result;
      },
      showDialog(title, message, variant) {
        options.$swal(title, message, variant);
      },
      mmoParlayResult: function(item) {
        let pay_odds = item.payout_odds;
        let status = item.status;
        let detail_status = item.detail_status;
        switch (true) {
          case pay_odds === 0:
            return options.$i18n.messages[options.$i18n.locale].ui.lose;
          case pay_odds > 0 && pay_odds < 1:
            return options.$i18n.messages[options.$i18n.locale].ui.lose_half;
          case pay_odds === 1:
            // return options.$i18n.messages[options.$i18n.locale].ui.draw_cancel;
            if(detail_status == 2) {
              return options.$i18n.messages[options.$i18n.locale].ui.void;
            } else {
              if(status == 5) {
                return options.$i18n.messages[options.$i18n.locale].ui.abandoned;
              } else if(status == 2) {
                return options.$i18n.messages[options.$i18n.locale].ui.cancel;
              } else {
                return options.$i18n.messages[options.$i18n.locale].ui.draw_cancel;
              }
            }
            break;
          case pay_odds > 1 && pay_odds < 2:
            return options.$i18n.messages[options.$i18n.locale].ui.win_half;
          case pay_odds === 2:
            return options.$i18n.messages[options.$i18n.locale].ui.win;
          default:
            return "Running";
        }
      },
      showWinStatus: function(item) {
        let pay_odds = item.payout_odds;
        let ori_odds = item.odds_display;
        let status = item.status;
        let detail_status = item.detail_status;
        switch (true) {
          case pay_odds === 0:
            return options.$i18n.messages[options.$i18n.locale].ui.lose;
          case pay_odds > 0 && pay_odds < 1:
            return options.$i18n.messages[options.$i18n.locale].ui.lose_half;
          case pay_odds === 1:
            // return options.$i18n.messages[options.$i18n.locale].ui.draw_cancel;
            if(detail_status == 2) {
              return options.$i18n.messages[options.$i18n.locale].ui.void;
            } else {
              if(status == 5) {
                return options.$i18n.messages[options.$i18n.locale].ui.abandoned;
              } else if(status == 2) {
                return options.$i18n.messages[options.$i18n.locale].ui.cancel;
              } else {
                return options.$i18n.messages[options.$i18n.locale].ui.draw_cancel;
              }
            }
            break;
          case pay_odds < ori_odds && pay_odds > 1:
            return options.$i18n.messages[options.$i18n.locale].ui.win_half;
          case pay_odds > 1:
            return options.$i18n.messages[options.$i18n.locale].ui.win;
          default:
            return "Running";
        }
        // let result = "";
        // if (pay_odds == ((ori_odds-1)/2 + 1)) {
        //   result = options.$i18n.messages[options.$i18n.locale].ui.win_half;
        // } else {
        //   if(pay_odds > 1) {
        //     result = options.$i18n.messages[options.$i18n.locale].ui.win;
        //   } else {
        //     switch (pay_odds) {
        //       case 0:
        //         result = options.$i18n.messages[options.$i18n.locale].ui.lose;
        //         break;
        //       case 0.5:
        //         result = options.$i18n.messages[options.$i18n.locale].ui.lose_half;
        //         break;
        //       case 1:
        //         result = options.$i18n.messages[options.$i18n.locale].ui.draw_cancel;
        //         break;
        //     //   default:
        //     //     result = options.$i18n.messages[options.$i18n.locale].ui.won;
        //     //     break;
        //     }
        //   }
        // }
        // return result;
      },
      objSize: function(obj) {
        var size = 0, key;
        for (key in obj) {
          if (obj.hasOwnProperty(key)) size++;
        }
        return size;
      },
      playTouchSound(number) {
        // Use your own sound file
        // var audio = new Audio('sound/iphone_keypad_sound.mp3');
        var audio = new Audio()
        audio.preload = 'auto'
        audio.src = 'sound/iphone_keypad_sound.mp3'
        audio.play()

        
        // You can also perform additional actions here based on the clicked number
        // console.log('Clicked number: ' + number);
      }
    };
  }
};
